import "./transaction-type.scss";
import IconCircleArrowDown from "../../../../../components/icons/icon-circle-arrow-down/icon-circle-arrow-down";
import IconCircleArrowUp from "../../../../../components/icons/icon-circle-arrow-up/icon-circle-arrow-up";
import Icon from '../../../../../components/icons/icon/icon';
import { TRANSACTION_TYPES } from "../../../../../services/api/transactions-service";
import IconAdjustedUp from "../../../../../components/icons/icon-adjusted-up/icon-adjusted-up";
import IconAdjustedDown from "../../../../../components/icons/icon-adjusted-down/icon-adjusted-down";
import { Tooltip } from "../../../../../components/tooltip/tooltip";
import IconInfo from "../../../../../components/icons/icon-info/icon-info";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";

interface ITransactionType {
    transaction_type_id: number;
    cash: number;
    credits: number;
    gift_card: number;
    refund_provider?: string;
}

const TansactionType: React.FC<ITransactionType> = ({ transaction_type_id, cash, credits, gift_card, refund_provider }) => {
    if (!(credits > 0 || cash > 0 || gift_card > 0)) {
        return null;
    }

    let content = null;

    if (transaction_type_id === TRANSACTION_TYPES.STORE_SPENT) {
        content = <><Icon Component={IconCircleArrowUp} /> <FontBody2> Purchase </FontBody2></>;
    }

    if (transaction_type_id === TRANSACTION_TYPES.PAYMENT_AUTHORIZATION) {
        content = <FontBody2>Authorization</FontBody2>;
    }

    if (transaction_type_id === TRANSACTION_TYPES.PAYMENT_CAPTURE) {
        content = <><Icon Component={IconCircleArrowUp} /> <FontBody2> Capture </FontBody2> </>;
    }

    if (transaction_type_id === TRANSACTION_TYPES.INVOICE) {
        content = <><Icon Component={IconCircleArrowUp} /> <FontBody2> Invoice</FontBody2></>;
    }

    if (transaction_type_id === TRANSACTION_TYPES.ORIG_PAYMENT ||
        transaction_type_id === TRANSACTION_TYPES.ACCEPTED_OFFER ||
        transaction_type_id === TRANSACTION_TYPES.REFUND_TO_BANK) {
        content = <>
            <Icon Component={IconCircleArrowDown} /> <FontBody2> Refund </FontBody2>            
            {refund_provider &&
                <Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>Refund by {refund_provider}</FontBody2>}>
                    <Icon Component={IconInfo} />
                </Tooltip>
            }
        </>;
    }

    if (transaction_type_id === TRANSACTION_TYPES.CREDIT_ADJUSTMENT_WITHDRAW) {
        content = <><FontBody2> Adjusted </FontBody2> <Icon Component={IconAdjustedUp} /></>;
    }

    if (transaction_type_id === TRANSACTION_TYPES.CREDIT_ADJUSTMENT_ISSUE) {
        content = <><FontBody2> Adjusted </FontBody2> <Icon Component={IconAdjustedDown} /></>;
    }

    if (transaction_type_id === TRANSACTION_TYPES.INVOICE_ADJUSTMENT_POSITIVE) {
        content = <><FontBody2> Exchange Adjustment </FontBody2> <Icon Component={IconAdjustedUp} /></>;
    }

    if (transaction_type_id === TRANSACTION_TYPES.INVOICE_ADJUSTMENT_NEGATIVE) {
        content = <><FontBody2> Exchange Adjustment </FontBody2> <Icon Component={IconAdjustedDown} /></>;
    }

    if (transaction_type_id === TRANSACTION_TYPES.INSTANT_REFUND_TYPE) {
        content = <>
            <Icon Component={IconCircleArrowDown} /><FontBody2> Refund </FontBody2>
            <Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>Instant refund by {refund_provider}</FontBody2>}>
                <Icon Component={IconInfo} />
            </Tooltip>
        </>;
    }

    return (
        <span className="transaction-type">
            {content}
        </span>
    );
}

export default TansactionType;
